import { IconBase, type IconProps } from './iconBase';

import type { JSX } from 'react';

export const Brush = ({ type, ...rest }: IconProps): JSX.Element => (
  <IconBase viewBox='0 0 24 24' {...rest}>
    {type === 'stroke' ? (
      <>
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M7.343 3.972a.25.25 0 0 0-.25.25v5.32h9.814v-5.32a.25.25 0 0 0-.25-.25h-1.518l-1.194 1.194a.75.75 0 0 1-1.061 0l-1.195-1.194zm9.564 7.07H7.093v2.61c0 .073.06.133.134.133a3.4 3.4 0 0 1 3.402 3.4v4.128c0 .138.112.25.25.25h2.243a.25.25 0 0 0 .25-.25v-4.128a3.4 3.4 0 0 1 3.401-3.4c.074 0 .134-.06.134-.134zm-11.314-.765v3.375c0 .902.732 1.633 1.635 1.633a1.9 1.9 0 0 1 1.9 1.9l.001 4.128c0 .967.784 1.75 1.75 1.75h2.243a1.75 1.75 0 0 0 1.75-1.75v-4.128a1.9 1.9 0 0 1 1.9-1.9c.903 0 1.635-.731 1.635-1.634v-9.43a1.75 1.75 0 0 0-1.75-1.75h-1.828a.75.75 0 0 0-.53.22l-.885.884-.884-.884a.75.75 0 0 0-.53-.22H7.343a1.75 1.75 0 0 0-1.75 1.75z'
          fill='currentColor'
        />
      </>
    ) : (
      <>
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M14.47 2.563a.75.75 0 0 1 .359-.091h1.828c.967 0 1.75.783 1.75 1.75v9.43c0 .902-.731 1.633-1.634 1.633a1.9 1.9 0 0 0-1.901 1.9v4.128a1.75 1.75 0 0 1-1.75 1.75H10.88a1.75 1.75 0 0 1-1.75-1.75v-4.128a1.9 1.9 0 0 0-1.902-1.9c-.902 0-1.634-.73-1.634-1.633v-9.43a1.75 1.75 0 0 1 1.75-1.75H12a.75.75 0 0 1 .53.22l.885.883.883-.884a.8.8 0 0 1 .172-.128m2.437 8.48H7.094v2.609c0 .073.06.133.133.133a3.4 3.4 0 0 1 3.402 3.4v4.128c0 .138.112.25.25.25h2.243a.25.25 0 0 0 .25-.25v-4.127a3.4 3.4 0 0 1 3.402-3.401c.074 0 .133-.06.133-.133z'
          fill='currentColor'
        />
      </>
    )}
  </IconBase>
);
